import type { TranslatesReplacements } from '@powerplay/core-minigames'

/**
 * Vymeny textov pre preklady - prekonkretnu disciplinu
 */
export const translatesReplacements: TranslatesReplacements[] = [

  {
    text: 'tutorialText11-2',
    replace: [
      {
        original: '[start]',
        new: 'START'
      }
    ]
  },
  {
    text: 'instructionsDisciplineTraining16Cell3Text1D',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },
  {
    text: 'instructionsDisciplineTraining16Cell3Text1M',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },
  {
    text: 'hint-16-0',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },
  {
    text: 'instructionsDiscipline16Cell3Text1',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },
  {
    text: 'instructionsDiscipline16Cell3Text1Mobile',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },
  {
    text: 'tutorialText16-3',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },
  {
    text: 'tutorialText16-3m',
    replace: [
      {
        original: '[number]',
        new: '35'
      }
    ]
  },

]
